module.exports = __webpack_public_path__ + "src/assets/static/img/appstore.3121e464.svg";